export default __webpack_public_path__ + "maps-overivew-annotation-image-960-a4ef90fdb4c20c4e93307c2d6a3151f9.webp";